class SortBy extends HTMLElement {
  constructor () {
    super()

    this.state = {
      root: window.theme.tagalys.results.stateLayer.state,
    }

    this.elements = {
      select: this.querySelector('[data-sort-by-el="select"]'),
      list: this.querySelector('[data-sort-by-el="list"]'),
    }

    // Store bound handlers for cleanup
    this._boundHandlers = {
      handleInitialized: () => {
        this.render()
      },
      handleChange: e => {
        this.handleChange(e)
      },
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.attachEventListeners()
  }

  disconnectedCallback () {
    this.unsubscribeFromEvents()
    this.detachEventListeners()
  }

  subscribeToEvents () {
    window.theme.tagalys.results.eventBus.subscribe(
      'results:api:fetched:success',
      this._boundHandlers.handleInitialized,
    )
  }

  unsubscribeFromEvents () {
    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:api:fetched:success',
      this._boundHandlers.handleInitialized,
    )
  }

  attachEventListeners () {
    this.elements.select?.addEventListener(
      'change',
      this._boundHandlers.handleChange,
    )
  }

  detachEventListeners () {
    this.elements.select?.removeEventListener(
      'change',
      this._boundHandlers.handleChange,
    )

    this.elements.listItem?.removeEventListener(
      'change',
      this._boundHandlers.handleChange,
    )
  }

  handleChange (e) {
    window.theme.tagalys.results.SDK.helpers.applySortOption(e.target.value)

    window.theme.tagalys.results.eventBus.publish('results:ui:sort:changed')
  }

  render () {
    if (this.elements.select) {
      const sortOptions = window.theme.tagalys.results.SDK.helpers.getSortOptions()

      this.elements.select.innerHTML = sortOptions
        .map(
          option => `
            <option value="${option.id}" ${option.selected ? 'selected' : ''}>
              ${option.label}
            </option>
          `,
        )
        .join('')
    }

    if (this.elements.list) {
      const sortOptions = window.theme.tagalys.results.SDK.helpers.getSortOptions()

      this.elements.list.innerHTML = sortOptions
        .map(
          option => `
            <li class="clc-Sort_Item">
              <div class="clc-Sort_Option fz-14_171">
                <input
                  class="clc-Sort_OptionRadio"
                  id="${option.id}"
                  name="sort_by"
                  value="${option.id}"
                  type="radio"
                  ${option.selected ? 'checked' : ''}
                  data-sort-by-el="list-item"
                >

                <span class="clc-Sort_OptionRadioIcon"></span>

                <label
                  class="clc-Sort_OptionLabel"
                  for="${option.id}"
                >
                  ${option.label}
                </label>
              </div>
            </li>
          `,
        )
        .join('')

      // Re-attach event listeners to new list items
      const listItems = this.elements.list.querySelectorAll(
        '[data-sort-by-el="list-item"]',
      )
      listItems.forEach(item => {
        item.addEventListener('change', this._boundHandlers.handleChange)
      })
    }
  }
}

customElements.define('sort-by', SortBy)
